import { useField } from "formik";
import {
  DebugForm,
  DisplayFormErrors,
  InputField,
  VerticalForm,
} from "melco-shared-logic";
import { FullWidthSpace } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { MachineList } from "../machine/MachineList";
import { AddMachineDrawer } from "../machine/AddMachineDrawer";

export const DisplayMachineGroupDetailForm: React.FC = () => {
  const { t } = useTranslation();

  const [{ value: machines }] = useField<any[]>("machine_list");

  console.log(machines);

  const [isDrawerOpen, setDrawerOpen] = useState(false);

  return (
    <VerticalForm>
      <DisplayFormErrors />

      <FullWidthSpace direction="vertical" size="middle">
        <InputField

          maxLength={12}
          showCount
          name="name"
          label={t("reporting.machinegroups.details.form.name")}
        />
        <MachineList setDrawerOpen={setDrawerOpen} />
        <AddMachineDrawer
          isDrawerOpen={isDrawerOpen}
          setDrawerOpen={setDrawerOpen}
        />
      </FullWidthSpace>

      {false && <DebugForm />}
    </VerticalForm>
  );
};
